import axios from 'axios';



const locationOrigin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

// const $http = axios.create({

//   // for cors
//   withCredentials: true,
// });

// // cache buster
// $http.interceptors.request.use(config => {
//   const USE_CACHE_BUSTER = config.cache === undefined || !config.cache;

//   if (USE_CACHE_BUSTER) {
//     if (typeof config.params === 'undefined') config.params = {};
//     if (config.params && typeof config.params === 'object') {
//       if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
//         config.params.append('_', Date.now());
//       } else {
//         config.params._ = Date.now();
//       }
//     }
//     return config;
//   }
// });

const dataTypeMap = {
  xml : 'xml',
  json: 'json',
  html: 'html',
  js  : 'script',
  txt : 'text',
  csv : 'text',
};

const MIMES = {
  'html'   : {type: 'text/html'             , charset: true },
  'jpg'    : {type: 'image/jpeg'            , charset: false},
  'jpeg'   : {type: 'image/jpeg'            , charset: false},
  'png'    : {type: 'image/png'             , charset: false},
  'gif'    : {type: 'image/gif'             , charset: false},
  'svg'    : {type: 'image/svg+xml'         , charset: false},
  'csv'    : {type: 'text/csv'              , charset: true },
  'js'     : {type: 'application/javascript', charset: true },
  'css'    : {type: 'text/css'              , charset: true },
  'xml'    : {type: 'text/xml'              , charset: true },
  'json'   : {type: 'application/json'      , charset: true },
  'default': {type: 'text/plain'            , charset: true },
};

const $http = {
  defaults: {
    type: 'get',
    cache: false,
  },
  getConfigByOpts(opts = {}, url) {
    opts = Object.assign({}, opts, this.defaults);
    opts.type     = opts.type     ? opts.type.toLowerCase()     : opts.type;
    opts.dataType = opts.dataType ? opts.dataType.toLowerCase() : opts.dataType;
    url = url || opts.url || '';

    const crossDomain = /^(http|https|\/\/)/.test(url) && !(new RegExp('^' + locationOrigin)).test(url);
    const extMatch = url.match(/(.*)(?:\.([^.]+$))/);
    const ext = extMatch && extMatch[2] && extMatch[2].split('?')[0].toLowerCase();
    opts.dataType = opts.dataType || dataTypeMap[ext];

    const config = {
      url,
      crossDomain,
      type: opts.type,
      timeout: opts.timeout,
      dataType: opts.dataType,
      contentType: opts.contentType,
      cache: opts.cache,
    };

    if (opts.data) config.data = opts.data;

    const mime = MIMES[ext];
    if (!opts.contentType && mime && mime.charset) {
      config.beforeSend = xhr => { xhr.overrideMimeType(`${mime.type};charset=utf-8`) }
    }

    return config;
  },
  request(type, url, opts) {
    return new Promise((resolve, reject) => {
      const config = Object.assign(this.getConfigByOpts(opts, url), {
        type,
        success: (data, status, xhr) => {
          resolve({
            data,
            status,
            xhr,
          });
        },
        error: (xhr, status, errorThrown) => {
          console.warn(`[dn.$http] リクエストに失敗しました。 ${url}`);
          reject(new Error(errorThrown));
        },
      });

      $.ajax(config);
    });
  },
  get(url, opts) {
    return this.request('get', url, opts);
  },
  post(url, opts = {}) {
    return this.request('post', url, opts);
  },
};




export default $http;


// WEBPACK FOOTER //
// ./src/js/middleware/http.js